import type { PatternInsight } from '../../../hooks/useAdvancedInsights';

interface Props {
  patterns: PatternInsight[];
  isBasic?: boolean;
  totalAvailable?: number;
}

const typeStyle: Record<PatternInsight['type'], { bg: string; text: string; border: string }> = {
  warning: { bg: 'bg-amber-50', text: 'text-amber-700', border: 'border-amber-200' },
  success: { bg: 'bg-emerald-50', text: 'text-emerald-700', border: 'border-emerald-200' },
  info: { bg: 'bg-sky-50', text: 'text-sky-700', border: 'border-sky-200' },
  tip: { bg: 'bg-violet-50', text: 'text-violet-700', border: 'border-violet-200' },
};

export const InsightsPatternsSection = ({ patterns, isBasic = false, totalAvailable = 0 }: Props) => {
  const locked = totalAvailable - patterns.length;

  if (!patterns.length && !isBasic) return null;

  return (
    <div>
      <div className="flex items-center gap-2 mb-4">
        <div className="w-8 h-8 flex items-center justify-center bg-amber-50 rounded-xl">
          <i className="ri-brain-line text-amber-500 text-[16px]" />
        </div>
        <div>
          <h2 className="text-[15px] font-700 text-gray-900">Padrões Financeiros</h2>
          <p className="text-[12px] text-gray-400">Análise automática do seu comportamento este mês</p>
        </div>
      </div>

      {patterns.length === 0 && (
        <div className="bg-gray-50 rounded-2xl border border-gray-100 px-5 py-8 text-center">
          <i className="ri-add-circle-line text-[28px] text-gray-300 mb-2 block" />
          <p className="text-[13px] text-gray-400">Registre lançamentos este mês para ver seus padrões financeiros.</p>
        </div>
      )}

      <div className="space-y-2">
        {patterns.map((p) => {
          const s = typeStyle[p.type];
          return (
            <div key={p.id} className={`flex items-start gap-3 px-4 py-3.5 rounded-2xl border ${s.bg} ${s.border}`}>
              <div className={`w-7 h-7 flex items-center justify-center shrink-0 ${s.bg} rounded-xl mt-0.5`}>
                <i className={`${p.icon} ${s.text} text-[15px]`} />
              </div>
              <div>
                <p className={`text-[13px] font-700 ${s.text}`}>{p.title}</p>
                <p className={`text-[12px] font-400 mt-0.5 ${s.text} opacity-80`}>{p.message}</p>
              </div>
            </div>
          );
        })}

        {isBasic && locked > 0 && (
          <div className="flex items-center gap-3 px-4 py-3.5 rounded-2xl border border-dashed border-gray-200 bg-gray-50">
            <div className="w-7 h-7 flex items-center justify-center shrink-0 bg-gray-100 rounded-xl">
              <i className="ri-lock-line text-gray-400 text-[14px]" />
            </div>
            <p className="text-[12px] text-gray-500">
              +{locked} padrão{locked > 1 ? 's' : ''} disponível{locked > 1 ? 'is' : ''} no plano avançado.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
